import type {
	IssueAppProps,
	IssueAppWithCriticalQueryPreloader as IssueAppType,
} from '@jira/issue__issue-view/src/IssueAppEntrypoint.tsx';
import { lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * This is specifically for prefetching, and should be handled by automation down the track
 */

export const LazyIssueApp: LazyComponent<(props: IssueAppProps) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint<typeof IssueAppType>(
		() =>
			import(
				/* webpackChunkName: "async-issue-app" */ '@jira/issue__issue-view/src/IssueAppEntrypoint.tsx'
			).then((module) => module.IssueAppWithCriticalQueryPreloader),
		{ ssr: false },
	);
